/**
 * Типы квиза в LMS
 */
export enum EQuizType {
  Poll = 'poll',
  Test = 'test',
}
